.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.4rem 0.7rem 0.2rem 0.7rem;
	flex-wrap: wrap;
}

.left {
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	min-width: 0;
	flex: 1 1 auto;
}

.titleWrapper {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	min-width: 0;
	flex: 1;
}

.backButton {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	border-radius: 6px;
	background-color: #f3f4f6;
	color: #6b7280;
	cursor: pointer;
	transition: all 0.2s ease;
	flex-shrink: 0;
	margin-top: 0.125rem;

	&:hover {
		background-color: #e5e7eb;
		color: #1f2937;
	}

	&:active {
		transform: scale(0.95);
	}
}

.quickActions {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.title {
	margin: 0;
	font-size: 1.25rem;
	line-height: 1.75rem;
	font-weight: 600;
	color: #1f2937;
	overflow-wrap: anywhere;
}

.subtitle {
	margin: 0;
	font-size: 0.8rem;
	color: #6b7280;
}

.breadcrumb {
	ol {
		display: flex;
		align-items: center;
		gap: 0.35rem;
		flex-wrap: wrap;
		margin: 0;
		padding: 0;
		list-style: none;
	}
}

.crumb {
	display: inline-flex;
	align-items: center;
	gap: 0.35rem;
}

.crumbLink,
.crumbBtn {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	font-weight: 600;
	color: #111827;
	background: transparent;
	border: 0;
	padding: 0;
	text-decoration: none;
	cursor: pointer;
}
.crumbLink:hover,
.crumbBtn:hover {
	color: #374151;
}
.crumbBtn:disabled {
	cursor: default;
	opacity: 0.6;
}

.crumbCurrent {
	color: #6b7280;
	pointer-events: none;
}

.sep {
	width: 18px;
	height: 18px;
	color: #9ca3af;
}

.actions {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex: 0 0 auto;
}

.rightExtra {
	display: flex;
	align-items: center;
}

.fetchingIndicator {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem 0.75rem;
	background: #f9fafb;
	border-radius: 0.5rem;
	border: 1px solid #e5e7eb;
	color: #6b7280;
	font-size: 0.875rem;
	font-weight: 500;
	height: 36px;
}

.fetchingIcon {
	flex-shrink: 0;
	color: #7fb02f;
	animation: spin 1s linear infinite;
}

.fetchingText {
	white-space: nowrap;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}

.btnLabel {
	display: inline;
}

.dropdown {
	position: relative;
}

.menu {
	position: absolute;
	right: 0;
	top: calc(100% + 0.25rem);
	min-width: 12rem;
	background: #fff;
	border: 1px solid #e5e7eb;
	border-radius: 0.5rem;
	box-shadow:
		0 10px 15px -3px rgba(0, 0, 0, 0.1),
		0 4px 6px -2px rgba(0, 0, 0, 0.05);
	z-index: 50;
	padding: 0.25rem;
	list-style: none;
	margin: 0;

	li {
		list-style: none;
	}
}

.menuItem {
	width: 100%;
	text-align: left;
	background: transparent;
	border: 0;
	padding: 0.5rem 0.75rem;
	border-radius: 0.375rem;
	color: #111827;
	font-weight: 500;
	cursor: pointer;
	display: flex;
	align-items: center;
	gap: 0.5rem;
}
.menuItem:hover {
	background: #f3f4f6;
}

.menuItemIcon {
	flex-shrink: 0;
	color: #6b7280;
}

@media (max-width: 640px) {
	.header {
		align-items: stretch;
		flex-wrap: nowrap;
		padding: 0.55rem 0.5rem 0.35rem 0.5rem;
		gap: 0.4rem;
	}

	.left {
		flex: 1 1 auto;
		min-width: 0;
	}

	.subtitle {
		display: none;
	}

	.title {
		font-size: 1.05rem;
		line-height: 1.4;
	}

	.backButton {
		width: 28px;
		height: 28px;
	}

	.actions {
		flex-wrap: nowrap;
		justify-content: flex-end;
		margin-top: 0;
		flex-shrink: 0;
		gap: 0.3rem;
	}

	.btnLabel {
		display: none;
	}

	.fetchingText {
		display: none;
	}

	.fetchingIndicator {
		padding: 0.4rem;
		min-width: 32px;
		height: 32px;
		justify-content: center;
	}

	.breadcrumb ol {
		gap: 0.25rem;
	}

	.crumbBtn,
	.crumbLink {
		font-size: 0.78rem;
	}

	.sep {
		width: 14px;
		height: 14px;
	}
}
